import {
  gsap
} from 'gsap'

import {
  ScrollTrigger
} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  inserted: (el, binding) => {

    let scrollTrigger = {
      trigger: el,
      start: 'top 80%',
      markers: false,
      toggleActions: 'play none none none'
    };

    if (binding.value && binding.value.to.scrollTrigger) {
      scrollTrigger = Object.assign(scrollTrigger, binding.value.to.scrollTrigger);
    }

    if (binding.value && binding.value.to) {

      let animation = binding.value.to
      animation.scrollTrigger = scrollTrigger

      if (!binding.value.to.stagger) {
        gsap.to(el, animation)
      } else {

        var childs = [];

        for (var i = 0; i < el.childNodes.length; i++) {

          if (el.childNodes[i].className) {
            if (el.childNodes[i].className.includes(binding.value.staggerEl)) {
              childs.push(el.childNodes[i]);
            }
          }
        }

        gsap.to(childs, animation)

      }
    }
  }
}